import React from 'react';
import { formatDateLocal } from '../../../utility/utility_functions';

const searchDisclaimer = (
  updatedAt: string
) => `Property search results and related data are provided by the San Antonio Board of REALTORS® (SABOR) MLS through the SABOR MLS RESO Web API. Information is deemed reliable but not guaranteed and should be independently verified by the consumer.

Search results may include active, pending, or off-market properties and are subject to prior sale, change, or withdrawal without notice. Neither the listing broker, participating brokers, information providers, nor SABOR MLS make any representations or warranties regarding the accuracy, completeness, or reliability of the information displayed within search results.

Search results are provided exclusively for personal, non-commercial use and may not be used for any other purpose.

Data sourced from SABOR MLS via RESO Web API.
Data last updated on ${updatedAt}.

Copyright © 2026 San Antonio Board of REALTORS®. All rights reserved.`;

export const SearchDisclaimer = ({ updatedAt }: { updatedAt: string }) => {
  return (
    <div>
      <h3 className="font-bold">SABOR MLS / RESO Search Results Disclaimer</h3>
      <p className="whitespace-pre-line">
        {searchDisclaimer(formatDateLocal(updatedAt))}
      </p>
    </div>
  );
};
